// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/KioskUploadPage.css */

.kiosk-upload-page {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
}

.kiosk-upload-card {
  width: 100%;
  max-width: 380px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  padding: 32px 26px;
  display: flex;
  flex-direction: column;
}

.kiosk-upload-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.kiosk-upload-brand img {
  height: 28px;
  width: 28px;
  object-fit: contain;
}

.kiosk-upload-brand span {
  font-family: var(--font-display);
  font-size: 17px;
  font-weight: 600;
  color: var(--text);
}

.kiosk-upload-brand .accent {
  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.kiosk-upload-card h1 {
  font-size: 24px;
  margin: 0 0 6px;
}

.kiosk-upload-sub {
  color: var(--text-muted);
  font-size: 13.5px;
  margin: 0 0 22px;
}

.kiosk-upload-label {
  display: block;
  color: var(--text-muted);
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 6px;
}

.kiosk-upload-card input[type="text"] {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--bg-elevated);
  color: var(--text);
  font-size: 16px;
  margin-bottom: 20px;
}

.kiosk-upload-card input[type="text"]:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
}

.kiosk-upload-photo {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 4 / 3;
  border: 1.5px dashed var(--border-strong);
  border-radius: var(--radius-md);
  background: var(--bg-elevated);
  cursor: pointer;
  overflow: hidden;
  margin-bottom: 10px;
  transition: border-color var(--fast) var(--ease);
}

.kiosk-upload-photo:hover {
  border-color: var(--accent);
}

.kiosk-upload-photo-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: var(--text-faint);
  font-size: 13.5px;
}

.kiosk-upload-photo-placeholder i {
  font-size: 26px;
  color: var(--text-muted);
}

.kiosk-upload-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.kiosk-upload-file {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  overflow: hidden;
}

.kiosk-upload-library {
  display: block;
  text-align: center;
  color: var(--text-muted);
  font-size: 13px;
  cursor: pointer;
  margin-bottom: 20px;
}

.kiosk-upload-library:hover {
  color: var(--text);
}

.kiosk-upload-error {
  color: var(--dislike);
  font-size: 13px;
  margin: -8px 0 16px;
}

.kiosk-upload-button {
  padding: 13px;
  border-radius: var(--radius-full);
  border: none;
  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));
  color: #1a0e05;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: transform var(--fast) var(--ease), box-shadow var(--fast) var(--ease);
}

.kiosk-upload-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: var(--shadow-accent);
}

.kiosk-upload-button:disabled {
  opacity: 0.55;
  cursor: default;
}

.kiosk-upload-button.secondary {
  background: var(--surface-hover);
  color: var(--text);
  margin-top: 22px;
}

.kiosk-upload-success {
  align-items: center;
  text-align: center;
}

.kiosk-upload-check {
  font-size: 40px;
  margin-bottom: 10px;
}

.kiosk-upload-success h1 {
  margin-bottom: 8px;
}

.kiosk-upload-success p {
  color: var(--text-muted);
  font-size: 14px;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/KioskUploadPage.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2EAA2E;EAC3E,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;EAC/B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,YAAY;EACZ,2EAA2E;EAC3E,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,SAAS;AACX","sourcesContent":["/* src/pages/KioskUploadPage.css */\n\n.kiosk-upload-page {\n  min-height: 100vh;\n  min-height: 100dvh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 20px;\n}\n\n.kiosk-upload-card {\n  width: 100%;\n  max-width: 380px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  padding: 32px 26px;\n  display: flex;\n  flex-direction: column;\n}\n\n.kiosk-upload-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.kiosk-upload-brand img {\n  height: 28px;\n  width: 28px;\n  object-fit: contain;\n}\n\n.kiosk-upload-brand span {\n  font-family: var(--font-display);\n  font-size: 17px;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.kiosk-upload-brand .accent {\n  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.kiosk-upload-card h1 {\n  font-size: 24px;\n  margin: 0 0 6px;\n}\n\n.kiosk-upload-sub {\n  color: var(--text-muted);\n  font-size: 13.5px;\n  margin: 0 0 22px;\n}\n\n.kiosk-upload-label {\n  display: block;\n  color: var(--text-muted);\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 6px;\n}\n\n.kiosk-upload-card input[type=\"text\"] {\n  width: 100%;\n  padding: 12px 14px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: var(--bg-elevated);\n  color: var(--text);\n  font-size: 16px;\n  margin-bottom: 20px;\n}\n\n.kiosk-upload-card input[type=\"text\"]:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-soft);\n}\n\n.kiosk-upload-photo {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  aspect-ratio: 4 / 3;\n  border: 1.5px dashed var(--border-strong);\n  border-radius: var(--radius-md);\n  background: var(--bg-elevated);\n  cursor: pointer;\n  overflow: hidden;\n  margin-bottom: 10px;\n  transition: border-color var(--fast) var(--ease);\n}\n\n.kiosk-upload-photo:hover {\n  border-color: var(--accent);\n}\n\n.kiosk-upload-photo-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  color: var(--text-faint);\n  font-size: 13.5px;\n}\n\n.kiosk-upload-photo-placeholder i {\n  font-size: 26px;\n  color: var(--text-muted);\n}\n\n.kiosk-upload-preview {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.kiosk-upload-file {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  overflow: hidden;\n}\n\n.kiosk-upload-library {\n  display: block;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 13px;\n  cursor: pointer;\n  margin-bottom: 20px;\n}\n\n.kiosk-upload-library:hover {\n  color: var(--text);\n}\n\n.kiosk-upload-error {\n  color: var(--dislike);\n  font-size: 13px;\n  margin: -8px 0 16px;\n}\n\n.kiosk-upload-button {\n  padding: 13px;\n  border-radius: var(--radius-full);\n  border: none;\n  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));\n  color: #1a0e05;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform var(--fast) var(--ease), box-shadow var(--fast) var(--ease);\n}\n\n.kiosk-upload-button:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-accent);\n}\n\n.kiosk-upload-button:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n\n.kiosk-upload-button.secondary {\n  background: var(--surface-hover);\n  color: var(--text);\n  margin-top: 22px;\n}\n\n.kiosk-upload-success {\n  align-items: center;\n  text-align: center;\n}\n\n.kiosk-upload-check {\n  font-size: 40px;\n  margin-bottom: 10px;\n}\n\n.kiosk-upload-success h1 {\n  margin-bottom: 8px;\n}\n\n.kiosk-upload-success p {\n  color: var(--text-muted);\n  font-size: 14px;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
